import Link from "next/link";
import React from "react";
import { FaArrowRightLong } from "react-icons/fa6";

const CommonButton = ({ href, name, className, arrow }) => {
    return (
        <div className={`${className} ${ arrow && "flex items-center gap-2"} cursor-pointer`}>
            {href ? <Link href={href}>{name}<span className="sr-only"> about contacting TanThetaa</span></Link> : { name }}
            {arrow && <FaArrowRightLong />}
        </div>
    );
};

export default CommonButton;
